module.exports = __webpack_public_path__ + "img/quizmayhem_banner_basketball.43ae89cb.jpg";